module.exports = __webpack_public_path__ + "img/xc-icon-2@2x.6c4340f0.png";